import { Injectable } from '@angular/core';

import { PublicAppointmentResponseDTO } from '@paymash/local-sdk/dto/response'; //todo  use dto from sdk
import { Appointment } from '@modules/core/models/appointment';

@Injectable({
  providedIn: 'root',
})
export class AppointmentMapper {
  public mapToEntity(dto: PublicAppointmentResponseDTO): Appointment {
    return {
      uuid: dto.uuid,
      appointmentId: dto.appointmentId,
      isCancelAllowedByCustomer: dto.isCancelAllowedByCustomer,
      status: dto.status,
      store: dto.store,
      company: dto.company,
      createdByEmployee: dto.createdByEmployee,
      services: dto.services,
      customer: dto.customer,
      startedAt: dto.startedAt,
      endedAt: dto.endedAt,
      createdAt: dto.createdAt,
      externalNote: dto.externalNote,
      invoiceId: '2-164', // todo change to real data
      paymentMethod: 'GENERIC_CC', // todo change to real data
      sequentId: 201, // todo change to real data
      invoiceUuid: '3274322-af23ere-werwer-2', // todo change to real data
  };
  }
}
